<div class="w-full" [formGroup]="formGroup">
  <p-select
    id="selectCountry"
    data-testid="country-select"
    [options]="countryOptions"
    formControlName="countryCode"
    optionLabel="label"
    optionValue="value"
    [filter]="true"
    filterBy="label"
    [showClear]="true"
    [placeholder]="'calculator.placeholder.countrySelect' | transloco"
    [fluid]="true"
    appendTo="body"
  >
  </p-select>
</div>
